/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Запрос на добавление/обновление статусов документа
 */
export interface DocumentStatusRequest {
  /** Тип документа */
  documentType: string;

  /** Наименования статусов документов, доступных для подписания указываются через запятую */
  statuses: string[];
}

export interface ErrorInfo {
  /**
   * Сообщение об ошибке
   * @example Ошибка обработки объекта
   */
  message: string;

  /** Код ошибки */
  errorCode:
    | "VALIDATION_ERROR"
    | "INTERNAL_ERROR"
    | "TIMEOUT_ERROR"
    | "ACCESS_DENIED";
}

/**
 * Запрос на добавление/обновление топиков продуктовых микросервисов
 */
export interface ProductTopicRequest {
  /** Тип документа */
  documentType: string;

  /** Вызываемый метод */
  method: "CCB_BUILD" | "SIGNATURE_CHECK" | "VISE_SIGNATURE_CHECK";

  /** Топик кафка для вызова запроса */
  topicReq: string;

  /** Топик кафка для получения ответа */
  topicPub: string;
}

/**
 * Запрос на добавление/обновление URI для вызова методов продуктовых микросервисов
 */
export interface ProductMethodRequest {
  /** Тип документа */
  documentType: string;

  /** Вызываемый метод */
  method: "CCB_BUILD";

  /** URI для вызова метода продуктового микросервиса */
  uri: string;
}

export interface DocumentReq {
  type?: string;
  id: string;
  system: string;
  status?: string;
  errorText?: string;
}

export interface TaskRequest {
  /** @format uuid */
  taskId?: string;
  documents: DocumentReq[];
  signingType?: "SIGN" | "VISE";
}

export interface SignatureData {
  /** Идентификатор документа */
  id: string;

  /** Тип документа */
  type?: string;

  /**
   * Система, в которой хранится и подписывается документ
   * @example ms
   */
  system: string;

  /**
   * Подпись в формате Base64
   * @example MIIMNgYJKMCAQExDj==
   */
  signature: string;
}

export interface SignatureRequest {
  documents: SignatureData[];
}

/**
 * Документы по которым необходимы статусы
 */
export interface DocumentsStatusReq {
  /** Идентификатор документа */
  id: string;

  /** Тип документа */
  type?: string;

  /** Система, в которой хранится и подписывается документ */
  system: string;
}

/**
 * Документы по которым необходим статус
 */
export interface DocumentsStatusRequest {
  /** Документы по которым необходимы статусы */
  documents: DocumentsStatusReq[];
}

/**
 * Статусы документов
 */
export interface DocumentsStatusResp {
  /** Идентификатор документа */
  id: string;

  /** Тип документа */
  type?: string;

  /** Система, в которой хранится и подписывается документ */
  system: string;

  /** Статус документа */
  state: string;

  /** Текст ошибки при подписания документа */
  errorText?: string;
}

export interface DocumentsStatusResponse {
  /** Статусы документов */
  documents: DocumentsStatusResp[];
}

export interface SigningError {
  /** Идентификатор документа */
  id: string;

  /** Тип документа */
  type?: string;

  /**
   * Система, в которой хранится и подписывается документ
   * @example ms
   */
  system: string;

  /** Текст ошибки */
  errorText?: string;
}

export interface SigningErrorsRequest {
  documents: SigningError[];
}

/**
 * Данные о сертификате
 */
export interface Certificate {
  /** Серийный номер сертификата, используемого для подписи */
  serial: string;

  /** Издатель сертификата, используемого для подписи */
  issuer: string;
}

export interface ProductTopicsResponse {
  topicMethods?: TopicMethod[];
}

export interface TopicMethod {
  method?: "CCB_BUILD" | "SIGNATURE_CHECK" | "VISE_SIGNATURE_CHECK";
  topicReq?: string;
  topicPub?: string;
}

export interface ProductMethodsResponse {
  methods?: URIMethod[];
}

export interface URIMethod {
  method?: "CCB_BUILD";
  uri?: string;
}

/**
 * Информация по процессу обработки документов
 */
export interface SignDocumentsStateInfo {
  /**
   * Общее количество документов в задании
   * @format int32
   */
  totalCount: number;

  /**
   * Количество документов, для которых выполнен текущий процесс
   * @format int32
   */
  processedCount: number;

  /**
   * Количество документов, для которых ещё не выполнен текущий процесс
   * @format int32
   */
  unprocessedCount: number;
}

export interface SignTaskStateResponse {
  /**
   * Идентификатор задания на массовое подписание
   * @format uuid
   */
  taskId: string;

  /**
   * Дата добавления задания
   * @format date-time
   */
  date: string;

  /** Текущий статус выполнения задания */
  state: string;

  /** Сообщение о возникшей ошибке */
  errorText: string;

  /** Информация по процессу обработки документов */
  documents: SignDocumentsStateInfo;
}

export interface GetCCBResponse {
  ccb?: string;
  ccbFormat?: string;
}

export interface CcbData {
  /** @format uuid */
  taskId: string;
  id: string;
  type?: string;
  system: string;
  data: string;
}

export interface CcbResponse {
  ccb?: CcbData[];
}

/**
 * Активные задачи
 */
export interface ActiveTask {
  /**
   * Идентификатор задания на массовое подписание
   * @format uuid
   */
  taskId: string;

  /**
   * Дата добавления задания
   * @format date-time
   */
  date: string;

  /** Статус выполнения задания */
  state: string;
}

export interface ActiveTasksResponse {
  /** Активные задачи */
  tasks: ActiveTask[];
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title МС Оркестратор массовой подписи
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://owb-plt-ms-bso.ndbo.dev.rshbdev.ru
 * @contact ООО РСХБ-ИНТЕХ <info@rshbintech.ru> (https://rshbintech.ru/)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags DocumentStatuses
     * @name GetDocumentVisedStatuses
     * @summary Получение списка статусов документов, доступных для визирования
     * @request GET:/api/bulk-sign-orchestrator/internal/v1/vised-doc-statuses
     */
    getDocumentVisedStatuses: (
      query: { documentType: string },
      params: RequestParams = {}
    ) =>
      this.request<string[], ErrorInfo>({
        path: `/api/bulk-sign-orchestrator/internal/v1/vised-doc-statuses`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DocumentStatuses
     * @name AddDocumentVisedStatuses
     * @summary Добавление или обновление списка статусов документов, доступных для визирования
     * @request POST:/api/bulk-sign-orchestrator/internal/v1/vised-doc-statuses
     */
    addDocumentVisedStatuses: (
      data: DocumentStatusRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorInfo>({
        path: `/api/bulk-sign-orchestrator/internal/v1/vised-doc-statuses`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DocumentStatuses
     * @name DeleteDocumentVisedStatuses
     * @summary Удаление списка статусов документов, доступных для визирования
     * @request DELETE:/api/bulk-sign-orchestrator/internal/v1/vised-doc-statuses
     */
    deleteDocumentVisedStatuses: (
      query: { documentType: string },
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorInfo>({
        path: `/api/bulk-sign-orchestrator/internal/v1/vised-doc-statuses`,
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DocumentStatuses
     * @name GetDocumentStatuses
     * @summary Получение списка статусов документов, доступных для подписания
     * @request GET:/api/bulk-sign-orchestrator/internal/v1/signed-doc-statuses
     */
    getDocumentStatuses: (
      query: { documentType: string },
      params: RequestParams = {}
    ) =>
      this.request<string[], ErrorInfo>({
        path: `/api/bulk-sign-orchestrator/internal/v1/signed-doc-statuses`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DocumentStatuses
     * @name AddDocumentStatuses
     * @summary Добавление или обновление списка статусов документов, доступных для подписания
     * @request POST:/api/bulk-sign-orchestrator/internal/v1/signed-doc-statuses
     */
    addDocumentStatuses: (
      data: DocumentStatusRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorInfo>({
        path: `/api/bulk-sign-orchestrator/internal/v1/signed-doc-statuses`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DocumentStatuses
     * @name DeleteDocumentStatuses
     * @summary Удаление списка статусов документов, доступных для подписания
     * @request DELETE:/api/bulk-sign-orchestrator/internal/v1/signed-doc-statuses
     */
    deleteDocumentStatuses: (
      query: { documentType: string },
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorInfo>({
        path: `/api/bulk-sign-orchestrator/internal/v1/signed-doc-statuses`,
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProductTopics
     * @name GetProductTopics
     * @summary Получение наименования топиков продуктовых микросервисов для получения данных через Кафка
     * @request GET:/api/bulk-sign-orchestrator/internal/v1/ms-product-topics
     */
    getProductTopics: (
      query: { documentType: string; method?: string },
      params: RequestParams = {}
    ) =>
      this.request<ProductTopicsResponse, ErrorInfo>({
        path: `/api/bulk-sign-orchestrator/internal/v1/ms-product-topics`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProductTopics
     * @name AddProductTopics
     * @summary Добавление или обновление наименований топиков продуктовых микросервисов для получения данных через Кафка
     * @request POST:/api/bulk-sign-orchestrator/internal/v1/ms-product-topics
     */
    addProductTopics: (data: ProductTopicRequest, params: RequestParams = {}) =>
      this.request<void, ErrorInfo>({
        path: `/api/bulk-sign-orchestrator/internal/v1/ms-product-topics`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProductTopics
     * @name DeleteProductTopics
     * @summary Удаление наименования топиков продуктовых микросервисов для получения данных через Кафка
     * @request DELETE:/api/bulk-sign-orchestrator/internal/v1/ms-product-topics
     */
    deleteProductTopics: (
      query: { documentType: string; method?: string },
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorInfo>({
        path: `/api/bulk-sign-orchestrator/internal/v1/ms-product-topics`,
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProductMethods
     * @name GetProductMethods
     * @summary Получение URI для вызова методов продуктовых микросервисов
     * @request GET:/api/bulk-sign-orchestrator/internal/v1/ms-product-methods
     */
    getProductMethods: (
      query: { documentType: string; method?: string },
      params: RequestParams = {}
    ) =>
      this.request<ProductMethodsResponse, ErrorInfo>({
        path: `/api/bulk-sign-orchestrator/internal/v1/ms-product-methods`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProductMethods
     * @name AddProductMethods
     * @summary Добавление или обновление URI для вызова методов продуктовых микросервисов
     * @request POST:/api/bulk-sign-orchestrator/internal/v1/ms-product-methods
     */
    addProductMethods: (
      data: ProductMethodRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorInfo>({
        path: `/api/bulk-sign-orchestrator/internal/v1/ms-product-methods`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProductMethods
     * @name DeleteProductMethods
     * @summary Удаление URI для вызова методов продуктовых микросервисов
     * @request DELETE:/api/bulk-sign-orchestrator/internal/v1/ms-product-methods
     */
    deleteProductMethods: (
      query: { documentType: string; method?: string },
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorInfo>({
        path: `/api/bulk-sign-orchestrator/internal/v1/ms-product-methods`,
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags BulkSign
     * @name AddTask
     * @summary Добавление/пополнение задания на массовое подписание
     * @request POST:/api/bulk-sign-orchestrator/external/v1/tasks
     * @secure
     */
    addTask: (data: TaskRequest, params: RequestParams = {}) =>
      this.request<string, ErrorInfo>({
        path: `/api/bulk-sign-orchestrator/external/v1/tasks`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BulkVise
     * @name VerifyViseTask
     * @summary Проверка возможности массового визирования переданных документов
     * @request POST:/api/bulk-sign-orchestrator/external/v1/tasks/{taskId}/vise/verify
     * @secure
     */
    verifyViseTask: (taskId: string, params: RequestParams = {}) =>
      this.request<void, ErrorInfo>({
        path: `/api/bulk-sign-orchestrator/external/v1/tasks/${taskId}/vise/verify`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BulkVise
     * @name CheckViseSignatures
     * @summary Проверка завизированных подписей ККБ документов
     * @request POST:/api/bulk-sign-orchestrator/external/v1/tasks/{taskId}/vise/signatures
     * @secure
     */
    checkViseSignatures: (
      taskId: string,
      data: SignatureRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorInfo>({
        path: `/api/bulk-sign-orchestrator/external/v1/tasks/${taskId}/vise/signatures`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BulkSign
     * @name VerifySignTask
     * @summary Проверка возможности массового подписания переданных документов
     * @request POST:/api/bulk-sign-orchestrator/external/v1/tasks/{taskId}/verify
     * @secure
     */
    verifySignTask: (taskId: string, params: RequestParams = {}) =>
      this.request<void, ErrorInfo>({
        path: `/api/bulk-sign-orchestrator/external/v1/tasks/${taskId}/verify`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BulkSign
     * @name CheckSignatures
     * @summary Добавление подписей для документов в БД, подтверждение подписей
     * @request POST:/api/bulk-sign-orchestrator/external/v1/tasks/{taskId}/signatures
     * @secure
     */
    checkSignatures: (
      taskId: string,
      data: SignatureRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorInfo>({
        path: `/api/bulk-sign-orchestrator/external/v1/tasks/${taskId}/signatures`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BulkSign
     * @name StartSignTask
     * @summary Старт процесса массового подписания
     * @request POST:/api/bulk-sign-orchestrator/external/v1/tasks/{taskId}/sign-documents
     * @secure
     */
    startSignTask: (taskId: string, params: RequestParams = {}) =>
      this.request<void, ErrorInfo>({
        path: `/api/bulk-sign-orchestrator/external/v1/tasks/${taskId}/sign-documents`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BulkSign
     * @name GetDocumentsStatuses
     * @summary Получение статуса обработки запрошенных документов
     * @request POST:/api/bulk-sign-orchestrator/external/v1/tasks/{taskId}/get-documents-data
     * @secure
     */
    getDocumentsStatuses: (
      taskId: string,
      data: DocumentsStatusRequest,
      params: RequestParams = {}
    ) =>
      this.request<DocumentsStatusResponse, ErrorInfo>({
        path: `/api/bulk-sign-orchestrator/external/v1/tasks/${taskId}/get-documents-data`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BulkSign
     * @name SetSigningErrors
     * @summary Установка ошибок подписания документов
     * @request POST:/api/bulk-sign-orchestrator/external/v1/tasks/{taskId}/documents/signing-errors
     * @secure
     */
    setSigningErrors: (
      taskId: string,
      data: SigningErrorsRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorInfo>({
        path: `/api/bulk-sign-orchestrator/external/v1/tasks/${taskId}/documents/signing-errors`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BulkSign
     * @name SetCertificate
     * @summary Установка параметров сертификата, используемого для подписания документов
     * @request POST:/api/bulk-sign-orchestrator/external/v1/tasks/{taskId}/certificate
     * @secure
     */
    setCertificate: (
      taskId: string,
      data: Certificate,
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorInfo>({
        path: `/api/bulk-sign-orchestrator/external/v1/tasks/${taskId}/certificate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BulkSign
     * @name CancelSignTask
     * @summary Остановки процесса подписания
     * @request POST:/api/bulk-sign-orchestrator/external/v1/tasks/{taskId}/cancel
     * @secure
     */
    cancelSignTask: (taskId: string, params: RequestParams = {}) =>
      this.request<void, ErrorInfo>({
        path: `/api/bulk-sign-orchestrator/external/v1/tasks/${taskId}/cancel`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags InitialReplication
     * @name InitialReplicationAccessControl
     * @summary Первоначальная репликация управления доступами
     * @request GET:/api/bulk-sign-orchestrator/internal/v1/init-replication/rbac-actor-permission
     */
    initialReplicationAccessControl: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/bulk-sign-orchestrator/internal/v1/init-replication/rbac-actor-permission`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags InitialReplication
     * @name InitialReplicationClients
     * @summary Первичная репликация клиентов
     * @request GET:/api/bulk-sign-orchestrator/internal/v1/init-replication/clients
     */
    initialReplicationClients: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/bulk-sign-orchestrator/internal/v1/init-replication/clients`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags InitialReplication
     * @name RunInitialReplicationBranch
     * @summary Первичная репликация филиалов
     * @request GET:/api/bulk-sign-orchestrator/internal/v1/init-replication/branches
     */
    runInitialReplicationBranch: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/bulk-sign-orchestrator/internal/v1/init-replication/branches`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BulkSign
     * @name GetSignTaskStatus
     * @summary Получение статуса выполнения задания
     * @request GET:/api/bulk-sign-orchestrator/external/v1/tasks/{taskId}
     * @secure
     */
    getSignTaskStatus: (taskId: string, params: RequestParams = {}) =>
      this.request<SignTaskStateResponse, ErrorInfo>({
        path: `/api/bulk-sign-orchestrator/external/v1/tasks/${taskId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BulkSign
     * @name GetSpecificCcb
     * @summary Получение ККБ конкретного документа
     * @request GET:/api/bulk-sign-orchestrator/external/v1/tasks/{taskId}/documents/ccb
     * @secure
     */
    getSpecificCcb: (
      taskId: string,
      query: { id: string; type?: string; system: string },
      params: RequestParams = {}
    ) =>
      this.request<GetCCBResponse, ErrorInfo>({
        path: `/api/bulk-sign-orchestrator/external/v1/tasks/${taskId}/documents/ccb`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BulkSign
     * @name GetCcb
     * @summary Получение сформированных ККБ для подписи документов
     * @request GET:/api/bulk-sign-orchestrator/external/v1/tasks/{taskId}/ccb
     * @secure
     */
    getCcb: (
      taskId: string,
      query?: { offset?: number; limit?: number },
      params: RequestParams = {}
    ) =>
      this.request<CcbResponse, ErrorInfo>({
        path: `/api/bulk-sign-orchestrator/external/v1/tasks/${taskId}/ccb`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BulkSign
     * @name GetActiveTaskStates
     * @summary Получение статусов невыполненных заданий на массовое подписание
     * @request GET:/api/bulk-sign-orchestrator/external/v1/tasks/active
     * @secure
     */
    getActiveTaskStates: (params: RequestParams = {}) =>
      this.request<ActiveTasksResponse, any>({
        path: `/api/bulk-sign-orchestrator/external/v1/tasks/active`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
